const _ = require('lodash');
const appSettings = require('swa-app-config/settings');
const LandingPageAirReservationSearchForm = require('swa-landing-page/landing-air-reservation-search-form');
const LandingPageCarBookingSearchForm = require('swa-landing-page/landing-car-booking-search-form');
const LandingPageChangeCancelSearchForm = require('swa-landing-page/landing-air-reservation-search-form');
const LandingPageFlightStatusSearchForm = require('swa-landing-page/landing-flight-status-search-form');
const LandingPageHotelBookingSearchForm = require('swa-landing-page/landing-hotel-booking-search-form');
const LandingPageFlightSearchForm = require('swa-landing-page/landing-air-booking-search-form');
const TabNavigationHotData = require('swa-bootstrap-data/corporate/corporate-landing-page-tab-navigation-hot-data');
const { CarSection } = require('@swa-ui/car');

const { enableCarTrawler } = appSettings.getAppProps();
const defaultNavigationData = {
    flight: {
        buttonSize: 'large',
        icon: 'airplane',
        name: 'flight',
        panel: LandingPageFlightSearchForm,
        title: 'TEXT__FLIGHT_TITLE'
    },
    hotel: {
        buttonSize: 'large',
        icon: 'hotel',
        name: 'hotel',
        panel: LandingPageHotelBookingSearchForm,
        title: 'TEXT__HOTEL_TITLE'
    },
    car: {
        buttonSize: 'large',
        icon: 'car',
        name: 'car',
        panel: enableCarTrawler ? CarSection : LandingPageCarBookingSearchForm,
        title: 'TEXT__CAR_TITLE'
    },
    checkIn: {
        buttonSize: 'huge',
        icon: 'check-in',
        name: 'check-in',
        panel: LandingPageAirReservationSearchForm,
        title: 'TEXT__CHECK_IN_TITLE'
    },
    flightStatus: {
        buttonSize: 'huge',
        icon: 'clock',
        name: 'flight-status',
        panel: LandingPageFlightStatusSearchForm,
        title: 'TEXT__FLIGHT_STATUS_TITLE'
    },
    changeCancel: {
        buttonSize: 'huge',
        icon: 'change-flight',
        name: 'change/cancel',
        panel: LandingPageChangeCancelSearchForm,
        title: 'TEXT__CHANGE_CANCEL_TITLE'
    }
};

module.exports = _.merge(defaultNavigationData, TabNavigationHotData);
